import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FormService } from "../../dynamic-forms/form.service";
import { Dropdown } from "../../dynamic-forms/inputs/dropdown/dropdown.model";
import { StringHelper } from "../../utilities/contracts/string-helper";
import { GridConfiguration } from "../grid/models/grid-configuration.model";

@Component({
    selector: "app-custom-pagination",
    templateUrl: "./custom-pagination.component.html",
    styleUrls: ["./custom-pagination.component.scss"],
})
export class CustomPaginationComponent implements OnInit {

    @Output() fetchPage = new EventEmitter<string>();
    @Input() config: GridConfiguration;
    form: FormGroup;
    pageSizeControl: Dropdown;
    currentToken = "";
    previousStack: string[] = [];
    nextStack: string[] = [];

    constructor(private formService: FormService) {}

    ngOnInit(): void {
        this.clearHistory();
        this.pageSizeControl = new Dropdown(
            {
                key: "pageSize",
                hidden: false,
                options: this.config.pageSizeSelectableInputs,
            });
        this.form = this.formService.createFormGroup([this.pageSizeControl]);
    }

    pushToPrevious(token: string): void {
        if ((token || token?.trim() === "")) {
            this.previousStack.push(token);
        }
    }

    pushToNext(token: string): void {
        if (StringHelper.isAvailable(token)) {
            this.nextStack.push(token);
        }
    }

    setCurrentToken(token: string): void {
        this.currentToken = token;
    }

    getCurrentToken(): string {
        return this.currentToken;
    }

    clearHistory(): void {
        this.previousStack = [];
        this.nextStack = [];
        this.currentToken = "";
    }

    onNext(): void {
        if (this.nextStack.length === 0 || this.currentToken === this.nextStack[this.nextStack.length - 1]) {
            return;
        } else {
            this.pushToPrevious(this.currentToken);
            this.currentToken = this.nextStack.pop() || "";
        }
        this.raisePageEvent(this.currentToken);
    }

    onPrevious(): void {
        if (this.previousStack.length === 0 || this.currentToken === this.previousStack[this.previousStack.length - 1]) {
            return;
        } else {
            this.pushToNext(this.currentToken);
            this.currentToken = this.previousStack.pop() || "";
        }
        this.raisePageEvent(this.currentToken);
    }

    pageSizeChange(event: any): void {
        this.config.pageSize = event.value;
        this.clearHistory();
        this.raisePageEvent("");
    }

    raisePageEvent(token: string): void {
        this.fetchPage.emit(token);
    }
}
